import React, { FC, useEffect, useRef } from 'react';
import { TweenMax } from 'gsap';
import injectSheet from 'react-jss';
import parse from 'html-react-parser';
import styleSheet from './styles';

interface Props {
  position?: 'top' | 'bottom';
  duration?: number;
  text: string | JSX.Element;
  classes?: any;
  visible?: boolean;
  onComplete?: () => void;
}

const Toast: FC<Props> = (props: Props) => {
  const toastRef = useRef();
  const { position, duration, text, classes, visible, onComplete } = props;
  const closeToast = () => {
    TweenMax.killTweensOf(toastRef.current);
    TweenMax.to(toastRef.current, 0.35, {
      alpha: 0,
      onComplete: onComplete || null,
    });
  };

  useEffect(() => {
    if (toastRef.current) {
      TweenMax.killTweensOf(toastRef.current);
      // Animate in//
      TweenMax.set(toastRef.current, { alpha: 0 });
      TweenMax.to(toastRef.current, 0.35, { alpha: 1 });
      TweenMax.delayedCall(duration, () => {
        // Animate out and remove message//
        closeToast();
      });
    }
  }, [text]);

  return (
    <>
      {visible && (
        <button
          type="button"
          onClick={closeToast}
          ref={toastRef}
          className={`toast-test ${classes.toast} ${classes[position]}`}
        >
          <p>{(typeof text === 'string' && parse(text)) || text}</p>
        </button>
      )}
    </>
  );
};

Toast.defaultProps = {
  classes: {},
  onComplete: () => {},
  position: 'bottom',
  visible: false,
  duration: 5,
};

export default injectSheet(styleSheet)(Toast);
